import {z} from 'zod';
import {defineToolRegistryManifest} from '../../types/base-tool-types';
import {dataToolSchemas} from '../../utils/schemas';

const toolName = 'get-cms-collection-details' as const;

const argumentZod = z.object({
  collectionId: dataToolSchemas.collectionId,
});

export const getCMSCollectionDetailsManifest = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Get CMS collection details',
  family: 'cms',
  llmTool: {
    name: toolName,
    description:
      'Get detailed information about a CMS collection including all its fields, metadata, and configuration. Returns field types, requirements, help text, and other collection properties.',
    inputSchema: argumentZod,
  },
  type: 'server',
  permission: [
    {
      resource: 'SiteCollection',
      action: 'read',
      resolveResources: (args) => [
        {type: 'SiteCollection', id: args.collectionId},
      ],
    },
  ],
  confirmBeforeExecuting: false,
  isConcurrencySafe: () => true,
  isReadOnly: () => true,
});

export type GetCMSCollectionDetailsArgumentType = z.infer<typeof argumentZod>;
